import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";

export const customMarkerUserIconSelected = divIcon({
  html: renderToStaticMarkup(
    <i style={{ color: "#2E3233" }} className="far fa-star fa-1x" />
  ),
});
